import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaMicrophone, FaVideo } from 'react-icons/fa';

const MeetingModal = ({ show, onHide, meetingURL, setMeetingURL, onJoin }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="p-4">

        <div className="d-flex align-items-center bg-light border rounded-pill px-3 py-2">
          <FaVideo className="me-2 text-muted" />
          <Form.Control className="border-0 bg-transparent shadow-none" type="text" placeholder="Paste meeting URL to record" 
            value={meetingURL}
            onChange={(e) => setMeetingURL(e.target.value)}
          />
          <FaMicrophone className="ms-2 text-muted" />
        </div>

        <div className="text-end mt-3">
          <Button variant="secondary" className="me-2" onClick={onHide}>Cancel</Button>
          <Button variant="primary" onClick={onJoin}>Join</Button>
        </div>

      </Modal.Body>
    </Modal>
  );
};

export default MeetingModal;
